import { PagePagination } from '@components/core-ui/Pagination';
import {
  SortableTh,
  SortingDirection,
  Table as CoreTable,
  TableWrapper,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@components/core-ui/Table';
import { getAmericanTime } from '@helpers/getAmericanTimezone';

import { TProps } from './types/TProps';

const COLUMN_COUNT = 7;

export const Table = ({
  auditLogs,
  totalItemsCount,
  isLoading,
  sorting,
  page,
  onPageChange,
  pageSize,
  setPageSize,
  selectedAuditLogId,
  onRowClick,
}: TProps) => {
  return (
    <>
      <TableWrapper>
        <CoreTable>
          <Thead $sticky>
            <Tr>
              <SortableTh style={{ width: '15%' }} onClick={() => sorting.toggle('createdAt')}>
                Time
                {sorting.field === 'createdAt' && <SortingDirection reverse={sorting.reverse} />}
              </SortableTh>
              <Th style={{ width: '15%' }}>Entity type</Th>
              <Th style={{ width: '20%' }}>Entity id</Th>
              <Th style={{ width: '10%' }}>Action</Th>
              <Th style={{ width: '20%' }}>Business action</Th>
              <Th style={{ width: '15%' }}>Actor</Th>
              <Th style={{ width: '5%' }}>Changed fields</Th>
            </Tr>
          </Thead>
          <Tbody>
            {auditLogs.map((auditLog) => (
              <Tr
                key={auditLog.id}
                role="button"
                tabIndex={0}
                aria-label={`Audit entry ${auditLog.id}`}
                className={`cursor-pointer hover:bg-surface-muted ${
                  selectedAuditLogId === auditLog.id ? 'bg-surface-muted' : ''
                }`}
                onClick={() => onRowClick(auditLog)}
                onKeyDown={(event) => {
                  if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    onRowClick(auditLog);
                  }
                }}
              >
                <Td>{getAmericanTime(auditLog.createdAt, true, true)}</Td>
                <Td>{auditLog.entityType}</Td>
                <Td title={auditLog.entityId}>{auditLog.entityId}</Td>
                <Td>{auditLog.action}</Td>
                <Td>{auditLog.businessAction ?? '—'}</Td>
                <Td>
                  <div className="flex flex-col">
                    <span className="overflow-hidden text-ellipsis">{auditLog.actorLabel ?? '—'}</span>
                    <span className="text-xs text-foreground-muted">{auditLog.actorType}</span>
                  </div>
                </Td>
                <Td>{auditLog.changedFields.length}</Td>
              </Tr>
            ))}
            {!isLoading && auditLogs.length === 0 ? (
              <Tr>
                <Td className="text-foreground-muted" colSpan={COLUMN_COUNT}>
                  No audit entries match the filters
                </Td>
              </Tr>
            ) : null}
          </Tbody>
        </CoreTable>
      </TableWrapper>
      <PagePagination
        totalItemsCount={totalItemsCount}
        page={page}
        onPageChange={onPageChange}
        pageSize={pageSize}
        setPageSize={setPageSize}
      />
    </>
  );
};
